import httpClient from "@/plugins/axios";


export const getTenant = async () => {
    const response = await httpClient.get('/v1/tenant/');
    return response;
}

export const getTenantDepartments = async () => {
    const response = await httpClient.get('/v1/tenant/departments/');
    return response;
}